import { Fragment } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { createTheme, MenuItem, ThemeProvider, Typography } from '@mui/material';

const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
              fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '500'
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400'
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
            fontSize:'14px',
            fontWeight: '500'
          },
        },
      },
    },
  });

const AutoCompleteInput = ({tag, value, setValue, obj, setObj,  list, width, font}) => {
    // set width if not passed as prop
    if (width == null){
        width = '16.6vw';
    }
    // set font size if given as prop, else use default
    let style = {};
    if (font){
        style['fontSize'] = font; 
    }

    // event hander to change state variable when a dropdown value is click (redux state obj)
    const onInputChange = (e, values) => {
      setObj(values); 
    }

    // event handler to change state variable when textfield changes
    const onTextFieldChange = (e) =>{
        setValue(value => value = e.target.value);
    } 

    const filterOptions = createFilterOptions({
        stringify: ({ label, id }) => `${label}${id}`
    });

    return (
        // material ui autocomplete component
        <ThemeProvider theme={theme}>
            <div className='d-flex gap-2 align-items-center'> 
                <Typography>
                    {tag}
                </Typography>
                <FormControl fullWidth size='small' sx={{ width: width, minWidth: width }} >
                    <Autocomplete
                        value={obj}
                        options={list}
                        renderOption={(props, option) => (
                            <MenuItem 
                            sx={{whiteSpace:"collapse",borderBottom:"1px solid #E6EDF1"}}
                            {...props} 
                            key={option.id} >
                                {option.label + '\n' + option.id}
                            </MenuItem>
                        )}
                        getOptionsLabel={option => option.label}
                        renderInput={params => {
                            return (
                                <TextField 
                                    {...params} 
                                    variant="outlined" 
                                    fullWidth
                                    size='small'
                                    value={value}
                                    onChange={(e)=>onTextFieldChange(e)}
                                    placeholder={`Search ${tag}`}
                                />
                            )
                        }}
                        onChange={(e, values)=>onInputChange(e, values)}
                        disableClearable
                        filterOptions={filterOptions}
                    />
                </FormControl>
            </div>
        </ThemeProvider>                
    );
}

export default AutoCompleteInput;